import { createContext, useEffect, useState, useContext, useRef } from 'react';
import axios from 'axios';
import { API } from '../lib/axios';

export const ExtraContext = createContext();

export const ExtraProvider = ({ children }) => {
    const [activeCategory, setActiveCategory] = useState(null);
    const [scrollTarget, setScrollTarget] = useState(null);
    const [activeCollection , setActiveCollection ] = useState(null);


    const registerScrollTarget = (target) => {
        setScrollTarget(target);
    };

    const scrollToProducts = () => {
        if (scrollTarget) {
            scrollTarget.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
    };


  return (
    <ExtraContext.Provider value={{activeCategory,setActiveCategory,scrollToProducts,registerScrollTarget,activeCollection,setActiveCollection }}>
      {children}
    </ExtraContext.Provider>
  );
};

// Optional: Custom hook
export const useExtra = () => useContext(ExtraContext);
